var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalStorageWithCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.9821 2.3478v0.00136c-0.52887-3.791e-4 -1.0423 0.16812-1.4659 0.47826l-0.17662 0.13995c-0.39664 0.35008-0.66921 0.81708-0.7812 1.3302l-0.038041 0.22283-1.0896 8.7188-0.082875 0.5231v0.06386l19.3-0.0027 0.0014-0.07608-0.08019-0.5068-1.0747-8.7201-0.038037-0.22283c-0.096627-0.44204-0.3134-0.84993-0.62496-1.178l-0.16303-0.15625c-0.45583-0.39965-1.0433-0.61776-1.6493-0.61413v-0.00136zm-3.5786 11.739-0.027172 0.0027-0.027172 0.08153v5.0027c0 0.65726 0.26078 1.288 0.72549 1.7527l0.089668 0.08424c0.45457 0.41162 1.0468 0.64131 1.6629 0.64131h14.347c0.65721 0 1.2879-0.26078 1.7526-0.72554 0.46473-0.46477 0.72549-1.0955 0.72549-1.7527v-5.087z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.652 17.086c-0.03456 0-0.06795 0.01363-0.09237 0.03804-0.02449 0.02442-0.03804 0.0578-0.03804 0.09237 0 0.03456 0.01363 0.06795 0.03804 0.09237 0.02449 0.02449 0.0578 0.03805 0.09237 0.03805h5.2165c0.03456 0 0.06795-0.01356 0.09237-0.03805l0.02789-0.04208c0.0065-0.01579 0.01016-0.03289 0.01016-0.05028 0-0.01725-0.0038-0.03395-0.01016-0.04959l-0.02789-0.04277c-0.02442-0.02442-0.0578-0.03804-0.09237-0.03804z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.7874,
    cy: 17.218,
    r: 0.78256
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.046,
    cy: 17.217,
    r: 0.78256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.896 9.6432c2.5392 0 4.5976-2.0584 4.5976-4.5976s-2.0584-4.5976-4.5976-4.5976-4.5976 2.0584-4.5976 4.5976 2.0584 4.5976 4.5976 4.5976z",
    fill: "currentColor",
    strokeWidth: 0.91953
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.461 7.2879-1.6815-1.7997c-0.23016-0.24639-0.21701-0.63621 0.02942-0.86641 0.24634-0.23021 0.63622-0.21696 0.86638 0.029397l1.2971 1.3882 2.053-1.9182c0.01848-0.017269 0.03779-0.033094 0.05775-0.047641l0.96541-0.90205c0.24643-0.2302 0.63631-0.21695 0.86647 0.029434 0.23016 0.24636 0.21692 0.63621-0.02942 0.86642l-2.9488 2.7551-0.0031-0.00337-1.02 0.95305z",
    fill: "#fff",
    strokeWidth: 0.91953
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalStorageWithCheck);
export default __webpack_public_path__ + "static/media/local-storage-with-check.5171d678.svg";
export { ForwardRef as ReactComponent };